module.exports = __webpack_public_path__ + "img/160.4568cd3d.jpg";